import useSWRMutation from "swr/mutation";
import { ServicesURL, downloadFile, uploadFile } from "@utils/utilsApi";

export type EditionCsvEnrollmentKind = "users" | "groups";

interface UseEditionCsvEnrollmentArgs {
  editionId: number | string;
  corporateId: number | string;
  objectId: number | string;
  kind?: EditionCsvEnrollmentKind;
}

export const useEditionCsvEnrollment = ({
  editionId,
  corporateId,
  objectId,
  kind = "users",
}: UseEditionCsvEnrollmentArgs) => {
  const uploadBase =
    kind === "groups"
      ? ServicesURL.postEditionEnrollGroupCsv
      : ServicesURL.postEditionEnrollCsv;
  const templateUrl =
    kind === "groups"
      ? ServicesURL.getEditionEnrollGroupCsvTemplate
      : ServicesURL.getEditionEnrollCsvTemplate;

  const uploadUrl = `${uploadBase}?${new URLSearchParams({
    editionId: String(editionId),
    corporateId: String(corporateId),
    objectId: String(objectId),
  }).toString()}`;

  const { trigger: triggerUpload, isMutating } = useSWRMutation(
    uploadUrl,
    (url: string, { arg }: { arg: FormData }) => uploadFile(url, arg),
  );

  const uploadCsv = async (file: File): Promise<any> => {
    const formData = new FormData();
    formData.append("file", file);
    return triggerUpload(formData);
  };

  const downloadTemplate = () => downloadFile(templateUrl);

  return {
    uploadCsv,
    downloadTemplate,
    isUploading: isMutating,
  };
};
